import { render, staticRenderFns } from "./OperativeProfilePage.vue?vue&type=template&id=0dc4bb77&"
import script from "./OperativeProfilePage.vue?vue&type=script&lang=js&"
export * from "./OperativeProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports